import * as React from 'react';
import { useNavigate } from 'react-router-dom';

const CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
const REDIRECT_URI = `${process.env.REACT_APP_URL}/oauth2callback-google`;
const SCOPE = 'https://www.googleapis.com/auth/calendar https://www.googleapis.com/auth/userinfo.email';

const GoogleOAuthRedirect: React.FC = () => {
  const navigate = useNavigate();

  React.useEffect(() => {
    const url = `https://accounts.google.com/o/oauth2/v2/auth?response_type=code&client_id=${CLIENT_ID}&redirect_uri=${REDIRECT_URI}&scope=${SCOPE}&access_type=offline&prompt=consent`;
    window.location.href = url;
  }, [navigate]);

  return <></>;
};

export default GoogleOAuthRedirect;
